export const SET_MAP_DATA = 'SET_MAP_DATA'
export const SET_MAP_DISPLAY = '|A|SET_MAP_DISPLAY'
export const SET_MAP_ZOOM = '|A|SET_MAP_ZOOM'

export const setMapDisplayMode = mode => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_MAP_DISPLAY,
            mode,
        })
    }
}
export const setMapZoom = ({ min, max, level }) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_MAP_ZOOM,
            zoom: {
                min,
                max,
                level,
            },
        })
    }
}
